import React from 'react';
import { Link } from 'react-router-dom';
import '../validate/EmailValidation.css';  // Include your CSS file

const EmailValidatedFailure = () => {
  return (
    <div className="validation-container failure">
      <div className="validation-box">
        <h2 className="validation-title">Email Validation Failed</h2>
        <p className="validation-message">
          Unfortunately, the link is invalid or expired. Please try again or contact support.
        </p>
        {/* <Link to="/resend-validation" className="btn btn-failure">Resend Validation Email</Link>
        <Link to="/support" className="btn btn-secondary">Contact Support</Link> */}
      </div>
    </div>
  );
};

export default EmailValidatedFailure;
